import { Injectable } from '@angular/core';
import { Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { Material } from '../../../store/actions/userActions';
import { HttpService  } from '../../core/services/http/http.service';
@Injectable({
  providedIn: 'root'
})
export class IndividualService {

  constructor(private http: HttpService, private store: Store<any>) { }
  static formFields() {
    return {
      'y_identifier': [null,Validators.required]
   
    }
  }
  materialProvider(data)
  {
   return this.http.query('post', 'material-provider', {}, '', data);
  }

  dispatchMaterialProviderAction(payload)
  {
    this.store.dispatch(new Material(payload));
  }

}
